import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { DocumentWrapper } from '../../../components/DocumentWrapper/DocumentWrapper'
import document from './ProcessingOfPersonalData.md'

export const PersonalDataAgreementPage: FC = () => {
    const navigate = useNavigate()

    const handleBack = () => {
        navigate(-1)
    }

    const handleDownloadDocument = () => {
        window.open('/processing-of-personal-data.pdf')
    }

    return (
        <DocumentWrapper
            title="Обработка персональных данных"
            onBack={handleBack}
            onDownload={handleDownloadDocument}
            document={document}
        />
    )
}
